import { GridFilterModel } from '@mui/x-data-grid';
import { action, makeObservable, observable } from 'mobx';
import { API } from '~/api';
import { FeedbackDrawerModel } from '~/model/model.feedback.drawer';
import { GridStateModel } from '~/model/model.gridstate';
import { FeedbackListFilterFieldsDto } from '~/shared/dto/admin/feedback.dto';
import { Form } from '~/shared/form';
import { Async } from '~/shared/tools/async';
import { Singleton } from '../shared/service/service.base';
import { ApiService } from './service.api';

@Singleton()
export class FeedbackService {
	readonly drawer;
	readonly items = observable.array([] as API.Feedback[], { deep: false });
	readonly async = new Async();
	readonly gridState = new GridStateModel('feedback');

	@observable totalCount = 0;

	private filterModel?: GridFilterModel = undefined;

	public filterFieldsForm = Form.create(FeedbackListFilterFieldsDto, {
		name: 'FeedbackListFilterFieldsDto',
		validateOn: 'change',
		onChange: () => this.reload(),
	});

	constructor(private api: ApiService) {
		makeObservable(this);
		this.drawer = new FeedbackDrawerModel(this.api, this.reload);
	}

	@action.bound changeFilterModel(model: GridFilterModel) {
		this.filterModel = model;
		this.reload();
	}

	loadAndSubscribe = () => {
		this.reload();
		return this.gridState.subscribe(this.reload);
	};

	reload = () => {
		this.drawer.setSelectedItem(undefined);
		this.async.call(async () => {
			const filterFields = this.filterFieldsForm.getInstance();

			const { data } = await this.api.feedbackGetAll({
				filter: this.gridState.filterQuery,
				limit: this.gridState.pageSize,
				offset: this.gridState.offset,
				sort: this.gridState.sort,
				sortDir: this.gridState.sortDir,
				filterModel: JSON.stringify(this.filterModel?.items.map(i => ({ ...i, id: undefined }))),
				...filterFields,
			});
			return () => {
				this.items.replace(data.items);
				this.totalCount = data.total;
			};
		});
	};
}
